<template>
	<div class="menu">
		<img @click="hiddenMobile" class="menu-img" src="../../../public/images/close.png" alt="">
		<div class="menu-c">
			<div class="item" v-for="(item, index) in list" :key="index" @click="taplist(index, item)">
				<div v-if="index >= 9" class="sore">{{index+1}}</div>
				<div v-else class="sore">0{{index+1}}</div>
				 
				 <div class="line"></div> {{item.enname}}
			</div> 
		</div>
	</div>
</template>

<script>
	
	export default {
		props:{
			
		},
		data() {
			return {
				list: [{
						name: "首页",
						enname:"home",
						key: "index",
						path:"/en"
					},
					{
						name: "关于我们",
						enname:"About Us",
						key: "about",
						path:"/en/about"
					},
					{
						name: "业务与服务",
						enname:"Services",
						key: "service",
						path:"/en/service"
					},
					{
						name: "产品中心",
						enname:"Application",
						key: "product",
						path:"/en/product"
					},
					{
						name: "项目案例",
						enname:"Case",
						key: "case",
						path:"/en/case"
					},
					{
						name: "新闻媒体",
						enname:"Medium",
						key: "medium",
						path:"/en/medium"
					},
					{
						name: "下载中心",
						enname:"Download",
						key: "download",
						path:"/en/download"
					},
					{
						name: "联系我们",
						enname:"Contact Us",
						key: "contactus",
						path:"/en/contactus"
					},
					{
						name: "招贤纳士",
						enname:"Attract talents",
						key: "hire",
						path:"/en/hire"
					},
					{
						name: "中文",
						enname:"EN",
						key: "/",
						path:"/"
					},
				
				],

			}
		},
		watch:{
			
		},
		created() {

		},
		methods: {
			getBaseUrl(url) {
			    return url.split('?')[0];
			},
			taplist(index, item) {
				if(item.key == '/') {
					var currentURL = window.location.href;
					if (currentURL.includes("index")) {
					    this.$router.push("/en")
					}else if (currentURL.includes("about")) {
					    this.$router.push("/about")
					}else if (currentURL.includes("service")) {
					    this.$router.push("/service")
					}else if (currentURL.includes("product")) {
					    this.$router.push("/product")
					}else if (currentURL.includes("case")) {
					    this.$router.push("/case")
					}else if (currentURL.includes("medium")) {
					    this.$router.push("/medium")
					}else if (currentURL.includes("download")) {
					    this.$router.push("/download")
					}else if (currentURL.includes("contactus")) {
					    this.$router.push("/contactus")
					}else if (currentURL.includes("hire")) {
					    this.$router.push("/hire")
					}else {
					    this.$router.push("/")
					}
				}else if(item.key == 'index'){
					this.$router.push("/en")
				}else {
					this.$router.push(item.path)
				}
			},
			hiddenMobile(){
				this.$emit("hiddenMobile", {})
			}
		}
	}
</script>

<style lang="scss">
	.menu {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 1);
		z-index: 99999;
		
		.menu-img {
			position: absolute;
			top: 40px;
			right: 40px;
			width: 20px;
			height: 20px;
		}
		.menu-c {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.item {
				width: 100%;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				color: #f9f9f9;
				font-size: 15px;
				margin-top: 20px;
				.sort {
					
				}
				.line {
					width: 40px;
					height: 1px;
					margin-left: 10px;
					margin-right: 10px;
					background-color: #f9f9f9;
				}
			}
		}
		
	}
	
	@media screen and (min-width: 1200px) {
		.menu {
			display: none;
		}
	
	}
	@media screen and (max-width: 1200px) {
		.menu {
			display: block;
		}
	  
	}
	@media screen and (max-width: 880px) {
		.menu {
			display: block;
		}
	  
	}
</style>
